import mitt from 'mitt';

const signal = mitt();

const signals = {
  name: 'Signals',
  ping() {
    console.log('Ping');
  },
  signal,
}
export default ({ app }, inject) => {
  inject('signals', signals)
}